import axios from '../utils/axios';

const clientPath = (accountId, clientId) => `/accounts/${encodeURIComponent(accountId)}/oauth/clients${clientId ? `/${encodeURIComponent(clientId)}` : ''}`;
const request = async (method, url, data, config = {}) => {
  const response = await axios({ method, url, data, ...config });
  return response.data.data;
};

export const oauthApi = {
  clients: accountId => request('GET', clientPath(accountId)),
  create: (accountId, data) => request('POST', clientPath(accountId), data),
  update: (accountId, clientId, data) => request('PATCH', clientPath(accountId, clientId), data),
  rotate: (accountId, clientId) => request('POST', `${clientPath(accountId, clientId)}/secret`),
  remove: (accountId, clientId) => request('DELETE', clientPath(accountId, clientId)),
  grants: () => request('GET', '/users/self/connected-apps'),
  revoke: grantId => request('DELETE', `/users/self/connected-apps/${encodeURIComponent(grantId)}`),
};
